import { rem } from 'polished'
import styled from 'styled-components'
import { DRAWER_DETAIL_CONTENT_WIDTH } from '../constants'

export const ContentWrapper = styled.div`
  margin: 0 auto;
  padding: ${rem(24)};
  width: 100%;
  max-width: ${rem(DRAWER_DETAIL_CONTENT_WIDTH)};
  min-width: 0;
  box-sizing: border-box;
`
